/* eslint-disable no-nested-ternary */
/* eslint-disable max-len */
import { Col, Row, Timeline } from 'antd';
import ShowMoreData from 'Components/common/components/ShowMoreData';
import TagTip from 'Components/common/components/TagTip';
import React, { useState, useLayoutEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import {
  primaryFont, wMedium, primaryHeadingColor, maxWidth, retina, tabHeading, maxMobile, maxTablet,
} from 'Utils/utilsStyle';
import { actions as personProfileActions } from 'Slice/PersonProfileSlice';
import { navigationTabsPersonProfile, personCareer } from 'Selector/PersonProfileSelector';
import TagSkeleton from 'Components/common/skeleton/TagSkeleton';
import ShowLessData from 'Components/common/components/ShowLessData';
import TypoGraphySkeleton from 'Components/common/skeleton/TypoGraphySkeleton';
import { GetPersonProfileRequest } from 'Types/RequestBodies';
import { PersonAchievementsObject } from 'Types/PersonTypes';
import { useNavigate } from 'react-router-dom';
import PersonalityDetailSkeleton from 'Components/common/skeleton/PersonalityDetailSkeleton';
import MailBoxIconV2 from 'Components/common/assets/svgIcons/MailBoxIconV2';
import EducationBadgeIcon from 'Components/common/assets/svgIcons/EducationBadgeIcon';
import SkillsBadge from 'Components/common/assets/svgIcons/SkillsBadge';
import InitiativesIcons from 'Components/common/assets/svgIcons/InitiativesIcons';
import GoalsIconV2 from 'Components/common/assets/svgIcons/GoalsIconV2';
import BoardsAndCommitteesIcon from 'Components/common/assets/svgIcons/BoardsAndCommitteesIcon';
import AchievementsIcon from 'Components/common/assets/svgIcons/AchievementsIcon';
import HonorAndAwardsIcon from 'Components/common/assets/svgIcons/HonorAndAwardsIcon';
import { COMPANY_OVERVIEW_ROUTE, PERSONALITY_INSIGHTS_ROUTE, SEARCH_ROUTE } from 'Utils/Constants';
import CareerBadge from './CareerBadge';
import CareerTimeLine from './CareerTimeLine';
import EducationBadge from './EducationBadge';
import VolunteerWorkIcon from '../../common/assets/svgIcons/VolunteerWorkIcon';
import FinancialIcon from '../../common/assets/svgIcons/FinancialsIconV2';

type Props = {
  personId: number;
  personType?: string;
};

const defaultProps = {
  // personId: 0,
  personType: '',
};

const Wrapper = styled.div`
  .person-career-heading {
    ${tabHeading};
    @media all and (max-width: ${maxWidth}) , ${retina} {
      font-size: 22px;
      line-height: 26px;
    }
    @media all and (max-width: ${maxMobile}) {
      font-size: 16px;
      line-height: 20px;
    }
  }
  .pills-one-liner {
    padding-bottom: 16px;
  }
  .content-wrapper {
    padding: 0px 0px 0px 0px;
    @media all and (max-width: ${maxWidth}) , ${retina} {
      padding: 0px 0px 0px 0px;
    }
  }
  .company-career-area {
    .widget-row-one {
      max-height: 237px;
      overflow: hidden;
      @media all and (max-width: ${maxMobile}) {
        max-height: fit-content;
      }
    }
  }
  .personal-skills {
      @media all and (max-width: ${maxMobile}) {
        margin-top: 16px;
      }
    .widget-row-one {
      .skill-badges {
        max-height: 162px;
        overflow: hidden;
         @media all and (max-width: ${maxTablet}) and (min-width: ${maxMobile}) {
          max-height: 150px;
         }
         @media all and (max-width: ${maxMobile}) {
          max-height: fit-content;
          overflow: auto;
         }
      }
    }
  }
  .para-text {
    font-family: ${primaryFont};
    font-weight: ${wMedium};
    font-size: 16px;
    letter-spacing: -0.42px;
    line-height: 25px;
    color: #67696A;
    margin-bottom: 0px;
    white-space: pre-wrap;
    @media all and (max-width: ${maxWidth}) , ${retina} {
      font-size: 14px;
      line-height: 20px;
    }
  }
  .end-line {
    width: 100%;
    opacity: 0.1;
    background: #B6B6B6;
    height: 1px;
    display: block;
    margin-bottom: 16px;
  }
  .timeline-length-1 {
    .ant-timeline-item-head {
      display: none;
    }
  }
`;

const HeadingContent = styled.h6`
  font-family: ${primaryFont};
  font-weight: ${wMedium};
  font-size: 20px;
  letter-spacing: -0.42px;
  line-height: 30px;
  color: ${primaryHeadingColor};
  margin-bottom: 10;
  display : flex;
  align-items: center;
  @media all and (max-width: ${maxWidth}) , ${retina} {
    font-size: 18px;
    line-height: 26px;
  }
  @media all and (max-width: ${maxMobile}) {
    font-size: 16px;
    line-height: 20px;
  }
`;

const CareerWrapper = styled.div`
&.work-history {
  @media all and (max-width: ${maxWidth}) , ${retina} {
    margin-top: 8px;
  }
}
  &.board-and-committees-wrapper {
    .arrow-down-icon-wrapper{
      .arrow-down-icon{
        height: 14px;
        width: 13px;
        @media all and (max-width: ${maxMobile}) {
          height: 12px;
          width: 10px;
        }
      }
    }
  }
  border-radius: 16px;
  background-color: rgb(255,255,255);
  box-shadow: 0px 0px 24px rgb(0 0 0 / 10%);
  padding: 14px 24px 10px 24px;
  margin-bottom: 16px;
  .end-line {
    &:last-child {
      display: none;
    }
  }
  .arrow-down-icon-wrapper-col{
    .arrow-down-icon-wrapper{
      .arrow-down-icon{
        height: 14px;
        width: 13px;
        @media all and (max-width: ${maxMobile}) {
          height: 12px;
          width: 10px;
        }
      }
    }
  }
  .tag-tip {
    .anticon-search {
      svg{
        @media all and (max-width: ${maxMobile}) {
          font-size: 12px;
        }
      }
    }
    .tip-text {
      font-size: 14px;
      @media all and (max-width: ${maxWidth}) , ${retina} {
        font-size: 12px;
      }
      @media all and (max-width: ${maxMobile}) {
        font-size: 11px;
      }
    }
  }
`;

const UnOrderList = styled.ul`
&.manual-achievement{
  padding-left: 0px
}
  padding-left: 20px;
  .list-item {
    color: ${primaryHeadingColor};
    font-family: ${primaryFont};
    font-size: 14px;
    font-weight: ${wMedium};
    margin-bottom: 14px;
    @media all and (max-width: ${maxMobile}) {
      font-size: 12px;
      margin-bottom: 3px;
    }
  }
`;

const IconHolder = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  h6 {
    margin-bottom: 0px;
    margin-left: 12px;
  }
  .initiatives-icon {
    margin-left: -4px;
  }
`;

const PersonCareer: React.FC<Props> = function PersonCareer({ personId, personType }) {
  const dispatch = useDispatch();
  const personProfileCareer = useSelector(personCareer);
  const {
    loading, skills, title,
    manualBoardsAndCommittees,
    volunteerWork,
    workHistory,
    educationHistory,
    achievements,
    goals, initiative, compensationSalary,
    manualAchievements,
  } = personProfileCareer;

  const tabs = useSelector(navigationTabsPersonProfile);
  const navigate = useNavigate();
  const [showMoreEducation, setShowMoreEducation] = useState(true);
  const [showMoreWork, setShowMoreWork] = useState(true);
  const [showMoreSkills, setShowMoreSkills] = useState(false);
  const [showMoreBoardAndCommittee, setShowMoreBoardAndCommittee] = useState(true);

  const checkIf = (obj: PersonAchievementsObject) => Object.keys(obj).length > 0 && obj?.data?.length > 0;

  useLayoutEffect(() => {
    if (!loading && !tabs.includes('Career')) {
      const navLink = `${PERSONALITY_INSIGHTS_ROUTE}${personId}&personType=${personType || ''}`;
      navigate(navLink, { replace: true });
    }
    if (personId && !title) {
      const data: GetPersonProfileRequest = {
        personId,
        type: personType,
      };
      dispatch(personProfileActions.getPersonProfileCareer(data));
    }
  }, [personId, tabs]);
  const hasCompany = (name: string | undefined) => {
    if (name && name !== '') return true;
    return false;
  };
  const redirectToCompany = (id: number | undefined, handler: string, name: string) => {
    if (hasCompany(name)) {
      if (id !== undefined) {
        if (id > 0) {
          window.open(`${COMPANY_OVERVIEW_ROUTE}${id}`);
        } else {
          window.open(`${SEARCH_ROUTE}${name}&extend=company`);
        }
      } else {
        dispatch(personProfileActions.getPersonCareerCompany({
          companyName: name,
          companyUrl: handler,
        }));
      }
    }
  };

  return (
    <Wrapper className="career-wrapper">
      <span className="person-career-heading">
        Career
      </span>
      {
        loading
          ? <PersonalityDetailSkeleton /> : (
            <>
              {!loading && workHistory?.data?.length > 0 && (
                <CareerWrapper className="work-history">
                  <Row gutter={16}>
                    <Col span={24} xs={24} sm={24} md={24} className="arrow-down-icon-wrapper-col">
                      <IconHolder>
                        <MailBoxIconV2 />
                        <HeadingContent>
                          {workHistory?.title}
                        </HeadingContent>
                      </IconHolder>
                      {[...(showMoreWork
                        ? workHistory.data.slice(0, 2)
                        : workHistory.data),
                      ].map((data) => (
                        <>
                          <CareerBadge
                            logo={data?.image || ''}
                            title={data?.company || ''}
                            date={`${data?.totalPeriod || ''}`}
                            location={data?.location || ''}
                            onClick={() => redirectToCompany(data?.companyId, data?.companyHandler, data?.fullName || data?.company)}
                            onKeyPress={() => redirectToCompany(data?.companyId, data?.companyHandler, data?.fullName || data?.company)}
                          />
                          <CareerTimeLine>
                            {data.subExperience.map((subExperience) => (
                              <Timeline.Item color="#7E7E7E" className={`timeline-length-${data.subExperience.length || ''}`}>
                                {subExperience.designation
                                  && <span className="title-timeline">{subExperience.designation || ''}</span>}
                                {
                                  (subExperience.duration || subExperience.duration) && <span className="date-timeline">{`${subExperience.duration || ''} ${subExperience.duration ? '-' : ''} ${subExperience.period || ''}`}</span>
                                }
                                {
                                  subExperience.description
                                  && <span className="description-timeline">{subExperience.description || ''}</span>
                                }
                              </Timeline.Item>
                            ))}
                          </CareerTimeLine>
                          <span className="end-line" />
                        </>
                      ))}
                      {workHistory?.data?.length > 2 && (
                        showMoreWork
                          ? (
                            <ShowMoreData
                              onClick={() => setShowMoreWork(false)}
                              count={`${workHistory.data.length}`}
                              text="experiences"
                            />
                          ) : (
                            <ShowLessData
                              onClick={() => setShowMoreWork(true)}
                              text="show less"
                            />
                          )
                      )}
                    </Col>
                  </Row>
                </CareerWrapper>
              )}
              {!loading && educationHistory?.data?.length > 0 && (
                <CareerWrapper>
                  <Row gutter={16}>
                    <Col span={24} xs={24} sm={24} md={24} className="arrow-down-icon-wrapper-col">
                      <IconHolder>
                        <EducationBadgeIcon />
                        <HeadingContent>
                          {educationHistory?.title}
                        </HeadingContent>
                      </IconHolder>
                      {[...(showMoreEducation
                        ? educationHistory.data.slice(0, 2)
                        : educationHistory.data),
                      ].map((education) => (
                        <EducationBadge
                          degree={education?.degree || education?.department}
                          logo={education?.image}
                          date={education?.duration}
                          title={education?.institute}
                        />
                      ))}
                      {educationHistory.data.length > 2 && (
                        showMoreEducation
                          ? (
                            <ShowMoreData
                              onClick={() => setShowMoreEducation(false)}
                              count={`${educationHistory.data.length}`}
                              text="education"
                            />
                          ) : (
                            <ShowLessData
                              onClick={() => setShowMoreEducation(true)}
                              text="show less"
                            />
                          )
                      )}
                    </Col>
                  </Row>
                </CareerWrapper>
              )}
              {
                !loading && skills.data.length > 0 && (
                  <Row gutter={16}>
                    <Col span={24} xs={24} sm={24} md={24} className="company-career-area personal-skills">
                      <CareerWrapper>
                        {
                          loading
                            ? Array.from(Array(15).keys()).map((i) => (
                              <TagSkeleton key={i} />
                            ))
                            : (
                              <>
                                <IconHolder>
                                  <SkillsBadge />
                                  <HeadingContent>
                                    {skills?.title}
                                  </HeadingContent>
                                </IconHolder>
                                {
                                  [
                                    ...(!showMoreSkills ? skills.data.slice(0, 20)
                                      : skills.data)]
                                    .map((skill) => (
                                      <TagTip
                                        key={skill}
                                        title={skill}
                                        marginTopBottom="8px"
                                        marginRight="8px"
                                        marginTopBottomSm="3px"
                                      />
                                    ))
                                }
                              </>
                            )
                        }
                        {skills.data.length > 20 && (
                          !showMoreSkills
                            ? (
                              <ShowMoreData
                                onClick={() => setShowMoreSkills(true)}
                                count={`${skills.data.length}`}
                                text="skills"
                              />
                            ) : (
                              <ShowLessData
                                onClick={() => setShowMoreSkills(false)}
                                text="show less"
                              />
                            )
                        )}
                      </CareerWrapper>
                    </Col>
                  </Row>
                )
              }
              {loading
                ? (
                  <Row gutter={16} className="content-wrapper">
                    {Array.from(Array(3).keys()).map((i) => (
                      <Col span={24}>
                        <TypoGraphySkeleton key={i} />
                      </Col>
                    ))}
                  </Row>
                ) : (
                  <Row gutter={16} className="content-wrapper mb-50">
                    {([goals, initiative]).map((item) => {
                      if (!item || Object.keys(item).length === 0 || item.data.length === 0) return null;
                      return (
                        <Col span={24} key={item?.title}>
                          <CareerWrapper>
                            <IconHolder>
                              {item.title === 'Initiatives' ? <InitiativesIcons /> : <GoalsIconV2 />}
                              <HeadingContent>
                                {item?.title}
                              </HeadingContent>
                            </IconHolder>
                            <UnOrderList>
                              {
                                item?.data.map((data: string) => (
                                  <li className="list-item">
                                    {data}
                                  </li>
                                ))
                              }
                            </UnOrderList>
                          </CareerWrapper>
                        </Col>
                      );
                    })}

                    {[volunteerWork].map((item) => {
                      if (!item || Object.keys(item).length === 0 || item.data.length === 0) return null;
                      return (
                        <Col span={24} key={item?.title}>
                          <CareerWrapper>
                            <IconHolder>
                              <VolunteerWorkIcon />
                              <HeadingContent>
                                {item?.title}
                              </HeadingContent>
                            </IconHolder>

                            {
                              item?.data?.map((data) => (
                                <EducationBadge
                                  title={data?.name1}
                                  degree={data?.name2}
                                  date={data?.name3}
                                  noImage
                                />
                              ))
                            }
                          </CareerWrapper>
                        </Col>
                      );
                    })}

                    {[manualBoardsAndCommittees].map((item) => {
                      if (!item || Object.keys(item).length === 0 || item.data.length === 0) return null;
                      return (
                        <Col span={24} key={item?.title}>
                          <CareerWrapper className="board-and-committees-wrapper">
                            <IconHolder>
                              <BoardsAndCommitteesIcon />
                              <HeadingContent>
                                {item?.title}
                              </HeadingContent>
                            </IconHolder>

                            {
                              [...(showMoreBoardAndCommittee
                                ? item.data.slice(0, 2)
                                : item.data),
                              ].map((data) => (
                                <EducationBadge
                                  title={data?.name1}
                                  degree={data?.name2}
                                  date={data?.name3}
                                  noImage
                                />
                              ))
                            }
                            {manualBoardsAndCommittees.data.length > 2 && (
                              showMoreBoardAndCommittee
                                ? (
                                  <ShowMoreData
                                    onClick={() => setShowMoreBoardAndCommittee(false)}
                                    count={`${manualBoardsAndCommittees.data.length}`}
                                    text="board & committees"
                                  />
                                ) : (
                                  <ShowLessData
                                    onClick={() => setShowMoreBoardAndCommittee(true)}
                                    text="show less"
                                  />
                                )
                            )}
                          </CareerWrapper>
                        </Col>
                      );
                    })}

                    <Col span={24}>
                      {checkIf(achievements)
                        ? (
                          <CareerWrapper>
                            <IconHolder>
                              <HonorAndAwardsIcon />
                              <HeadingContent>
                                {achievements?.title}
                              </HeadingContent>
                            </IconHolder>
                            {achievements?.data.map((item) => {
                              if (Object.keys(item).length === 0) return null;
                              return (
                                <EducationBadge
                                  degree={item?.issuer}
                                  achDesc={item?.description}
                                  date={item?.date}
                                  title={item?.title}
                                  noImage
                                />
                              );
                            })}
                          </CareerWrapper>
                        ) : null}
                    </Col>
                    {[manualAchievements].map((item) => {
                      if (!item || Object.keys(item).length === 0 || item.data.length === 0) return null;
                      return (
                        <Col span={24} key={item?.title}>
                          <CareerWrapper>
                            <IconHolder>
                              <AchievementsIcon />
                              <HeadingContent>
                                {item?.title}
                              </HeadingContent>
                            </IconHolder>
                            <UnOrderList className="manual-achievement">
                              {
                                item?.data.map((data) => (
                                  <EducationBadge
                                    title={data?.name1}
                                    degree={data?.name2}
                                    date={data?.name3}
                                    achDesc={data?.name4}
                                    noImage
                                  />
                                ))
                              }
                            </UnOrderList>
                          </CareerWrapper>
                        </Col>
                      );
                    })}

                    {[compensationSalary].map((item) => {
                      if (!item || Object.keys(item).length === 0 || item.data.length === 0) return null;
                      return (
                        <Col span={24} key={item?.title}>
                          <CareerWrapper>
                            <IconHolder>
                              <FinancialIcon />
                              <HeadingContent>
                                {item?.title}
                              </HeadingContent>
                            </IconHolder>
                            <UnOrderList>
                              {
                                item?.data?.map((data) => (
                                  <li className="list-item">
                                    {data?.name1}
                                  </li>
                                ))
                              }
                            </UnOrderList>
                          </CareerWrapper>
                        </Col>
                      );
                    })}
                  </Row>
                )}
            </>
          )
      }
    </Wrapper>
  );
};

PersonCareer.defaultProps = defaultProps;
export default PersonCareer;
